
import { defineComponent, onMounted, ref } from 'vue'
import { message } from 'ant-design-vue'
import { listWorkers, PptWorker, releaseWorkerLease } from '@/services/admin'

export default defineComponent({
  name: 'WorkerManagement',
  setup() {
    const workers = ref<PptWorker[]>([])
    const loading = ref(false)
    const load = async () => {
      loading.value = true
      try {
        workers.value = await listWorkers()
      }
      finally {
        loading.value = false
      }
    }
    const recentlySeen = (worker: PptWorker) => !!worker.last_heartbeat_at && Date.now() - new Date(worker.last_heartbeat_at).getTime() < 180000
    const providerLabel = (provider: PptWorker['provider']) => provider === 'official' ? '官方线路' : '第三方线路'
    const statusLabel = (worker: PptWorker) => {
      if (worker.current_task_count > 0) return '处理中'
      if (recentlySeen(worker)) return '待命'
      return '未连接'
    }
    const statusClass = (worker: PptWorker) => {
      if (worker.current_task_count > 0) return 'status-pill--running'
      if (recentlySeen(worker)) return 'status-pill--idle'
      return 'status-pill--offline'
    }
    const heartbeatText = (worker: PptWorker) => {
      if (!worker.last_heartbeat_at) return '无记录'
      return new Date(worker.last_heartbeat_at).toLocaleString('zh-CN', { hour12: false })
    }
    const release = async (worker: PptWorker) => {
      const result = await releaseWorkerLease(worker.id)
      message.success(`已释放 ${result.released} 个任务`)
      await load()
    }
    onMounted(load)
    return { workers, loading, providerLabel, statusLabel, statusClass, heartbeatText, release, load }
  },
})
